export default (state, param) => {
  state.form.status = param
}



// WEBPACK FOOTER //
// ./src/store/modules/order_custom_form/mutations/setOrderCustomFormStatus.js